import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";

import {
  Box,
  Typography,
  Button,
  TextField,
  IconButton,
  Container,
  InputAdornment,
  Card,
  CardContent,
  Avatar,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon,
  Logout,
  EmailOutlined as EmailIcon,
  PasswordRounded,
  GradingOutlined,
  GppMaybeOutlined,
  DownloadOutlined,
  EditSquare,
} from "@mui/icons-material";

import {
  darkBg,
  darkerBg,
  lightBg,
  lightBg2,
  primary,
} from "../../constants/colors";
import Person from "../../assets/Person.svg";

import TermsOfUseModal from "../../components/TermsOfUse";
import PrivacyPolicy from "../../components/PrivacyPolicy";
import ChangePassword from "../../components/ChangePassword";
import UpdateProfile from "../../components/UpdateProfile";
import { API_URL } from "../../helpers/api_helper";
import { downloadConsentForm } from "../../helpers/Downloads";

const Profile = () => {
  const User = localStorage.getItem("User");
  const navigate = useNavigate();
  const {
    userData,
    isMobile,
    isSmallMobile,
    drawerOpen,
    setDrawerOpen,
    profileMenuAnchor,
    setProfileMenuAnchor,
  } = useAppContext();

  const [showUpdateProfile, setShowUpdateProfile] = useState(false);
  const [showTermsofUse, setShowTermsofUse] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [profilePicture, setProfilePicture] = useState(null);

  useEffect(() => {
    const user_ = JSON.parse(User);
    if (
      user_?.UserInfo?.User_Photo_Path !== null &&
      user_?.UserInfo?.User_Photo_Path !== ""
    ) {
      setProfilePicture(API_URL + user_?.UserInfo?.User_Photo_Path);
    } else {
      setProfilePicture(Person);
    }
  }, []);

  // const handleDownloadConsentForm = async () => {
  //   console.log("Downloading consent form...");
  //   const response = await downloadConsentForm();
  // };

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // background: gradientBg,
        height: "100vh",
        overflow: "hidden",
      }}
    >
      {showUpdateProfile ? (
        <UpdateProfile HandleClose={() => setShowUpdateProfile(false)} />
      ) : showTermsofUse ? (
        <TermsOfUseModal HandleClose={() => setShowTermsofUse(false)} />
      ) : showPrivacyPolicy ? (
        <PrivacyPolicy HandleClose={() => setShowPrivacyPolicy(false)} />
      ) : showChangePassword ? (
        <ChangePassword HandleClose={() => setShowChangePassword(false)} />
      ) : (
        <Card
          sx={{
            backgroundColor: lightBg2,
            minWidth: isMobile ? "95%" : "40%",
            borderRadius: "12px",
          }}
        >
          <CardContent sx={{ p: { xs: 1, sm: 2 } }}>
            <div
              style={{
                marginTop: "30px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={profilePicture}
                alt="profile image"
                style={{
                  width: 100,
                  height: 100,
                  objectFit: "cover",
                  borderRadius: "50%",
                  border: `2px solid ${primary}`,
                }}
              />
              <Button
                onClick={() => setShowUpdateProfile(true)}
                style={{
                  width: "200px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: "transparent",
                    fontSize: "14px",
                  }}
                  className="sf-regular sf-regular--dark"
                >
                  <EditSquare />
                </Avatar>
                <Typography className="sf-regular sf-regular--dark">
                  Update Avatar
                </Typography>
              </Button>
            </div>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: 1,
                  p: 1,
                  borderRadius: "8px",
                  cursor: "pointer",
                  backgroundColor: "#F5F5FF",
                }}
              >
                <Button
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    "&:hover": { backgroundColor: primary },
                  }}
                >
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: "transparent",
                      margin: "0px 10px 0px 0px",
                    }}
                  >
                    <EmailIcon className="sf-regular sf-regular--dark" />
                  </Avatar>
                  <Typography
                    fontSize="18px"
                    className="sf-regular sf-regular--dark"
                  >
                    Email
                  </Typography>
                </Button>
                <Button
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    "&:hover": { backgroundColor: primary },
                  }}
                  onClick={() => setShowChangePassword(true)}
                >
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: "transparent",
                      margin: "0px 10px 0px 0px",
                    }}
                  >
                    <PasswordRounded className="sf-regular sf-regular--dark" />
                  </Avatar>
                  <Typography
                    fontSize="18px"
                    className="sf-regular sf-regular--dark"
                  >
                    Password
                  </Typography>
                </Button>
                <Button
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    "&:hover": { backgroundColor: primary },
                  }}
                  onClick={() => setShowTermsofUse(true)}
                >
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: "transparent",
                      margin: "0px 10px 0px 0px",
                    }}
                  >
                    <GradingOutlined className="sf-regular sf-regular--dark" />
                  </Avatar>
                  <Typography
                    fontSize="18px"
                    className="sf-regular sf-regular--dark"
                  >
                    Terms of Use
                  </Typography>
                </Button>
                <Button
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    "&:hover": { backgroundColor: primary },
                  }}
                  onClick={() => setShowPrivacyPolicy(true)}
                >
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: "transparent",
                      margin: "0px 10px 0px 0px",
                    }}
                  >
                    <GppMaybeOutlined className="sf-regular sf-regular--dark" />
                  </Avatar>
                  <Typography
                    fontSize="18px"
                    className="sf-regular sf-regular--dark"
                  >
                    Privacy Policy
                  </Typography>
                </Button>
                {/* <Button
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    "&:hover": { backgroundColor: primary },
                  }}
                  onClick={handleDownloadConsentForm}
                >
                  <Avatar
                    sx={{
                      width: 32,
                      height: 32,
                      backgroundColor: "transparent",
                      margin: "0px 10px 0px 0px",
                    }}
                  >
                    <DownloadOutlined className="sf-regular sf-regular--dark" />
                  </Avatar>
                  <Typography
                    textAlign={"left"}
                    fontSize="18px"
                    className="sf-regular sf-regular--dark"
                  >
                    Download Consent Form
                  </Typography>
                </Button> */}
              </Box>

              {/* <Box
                // onClick={(e) => setProfileMenuAnchor(e.currentTarget)}
                onClick={(e) => {
                  localStorage.clear();
                  navigate("/login");
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  p: 1,
                  borderRadius: "8px",
                  cursor: "pointer",
                  backgroundColor: lightBg2,
                  "&:hover": { backgroundColor: primary },
                }}
              >
                <Avatar
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: "transparent",
                    fontSize: "18px",
                    margin: "0px 10px 0px 10px",
                  }}
                >
                  <Logout className="sf-regular sf-regular--dark" />
                </Avatar>
                <Typography className="sf-regular sf-regular--dark">
                  Logout
                </Typography>
              </Box> */}
            </Box>
          </CardContent>
        </Card>
      )}
    </Box>
  );
};

export default Profile;
